import http from "./http-commons";

class UsuariosService {
    
    async Ingreso(email, password) {   
        
          try {
          let respuesta = "OK"
           const datos = { username: email, password: password };           
           await http.post("/dj-rest-auth/login/", datos).then(result => {                 
            if (result.status === 200) {
              sessionStorage.setItem("token",result.data.key);
              respuesta = "OK";             
            } else {
              respuesta = "NOK";
            }
           });
            return respuesta;
          } catch (error) {  
            return "NOK";
          }
        } 

        async Salir() {             
          try {
          await http.post("/dj-rest-auth/logout/", {}, {headers: {'Authorization': `Token ${sessionStorage.getItem("token")}`}}).then(result => {
            return result.status;
          });
          } catch (error) {
            console.log ("error logout " + error);  
            return "NOK";
          }
        }  
        
        async RecuperarClave(email){
          try {
            let respuesta = "OK"
             const datos = { email: email };
             await http.post("/dj-rest-auth/password/reset/", datos).then(result => {                         
              if (result.status === 200) {               
                respuesta = "OK";             
              } else {
                respuesta = "NOK";
              }
             });
              return respuesta;
            } catch (error) {  
              return "NOK";
            }
        }

        async CambiarClave(password, password2){
          try {
            let respuesta = "OK"
             const datos = { "new_password1": password, "new_password2": password2 };
             await http.post("/dj-rest-auth/password/change/", datos, {headers: {'Authorization': `Token ${sessionStorage.getItem("token")}`}}).then(result => {                         
              if (result.status === 200) {               
                respuesta = "OK";             
              } else {
                respuesta = "NOK";
              }
             });
              return respuesta;
            } catch (error) {  
              console.log("error" + JSON.stringify(error));
              return "NOK";
            }
        }

        async ResetearClave(password, password2,uid,token){
          try {
            let respuesta = "OK"
             const datos = { "new_password1": password, "new_password2": password2, "uid": uid, "token" : token };
             await http.post("/dj-rest-auth/password/reset/confirm/", datos).then(result => {                         
              if (result.status === 200) {               
                respuesta = "OK";             
              } else {
                respuesta = "NOK";
              }
             });
              return respuesta;
            } catch (error) {  
              console.log("error" + JSON.stringify(error));
              return "NOK";
            }
        }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new UsuariosService();